import type { RefObject } from "react";
import useGoNavSlidingGhost from "./useGoNavSlidingGhost";
import "./GoNavSlidingGhost.css";

const FIRE_ARCS = ["a", "b"] as const;

export default function GoNavSlidingGhost({
  rootRef,
  active
}: {
  rootRef: RefObject<HTMLElement | null>;
  active: boolean;
}) {
  const ghostRect = useGoNavSlidingGhost(rootRef, active);

  if (!active || !ghostRect) {
    return null;
  }

  return (
    <div
      className="go-nav-sliding-ghost"
      style={{
        left: ghostRect.left,
        top: ghostRect.top,
        width: ghostRect.width,
        height: ghostRect.height
      }}
      data-testid="go-nav-sliding-ghost"
      aria-hidden="true"
    >
      <span className="go-nav-sliding-ghost__fire-ring">
        <span className="go-nav-sliding-ghost__fire-spin go-nav-sliding-ghost__fire-spin--base" />
        {FIRE_ARCS.map((layer) => (
          <span key={layer} className={`go-nav-sliding-ghost__fire-pivot go-nav-sliding-ghost__fire-pivot--${layer}`}>
            <span className={`go-nav-sliding-ghost__fire-arc go-nav-sliding-ghost__fire-arc--${layer}`} />
          </span>
        ))}
      </span>
    </div>
  );
}
